import { useTranslation } from 'react-i18next';

import Path from '../../Path';
import { useLanguage } from '../../i18n/useLanguage';

import type { FooterSection, NavItem } from './layoutTypes';

/** Contenu de la navigation du layout : un seul endroit à modifier quand de nouvelles pages arrivent. */
export const useLayoutNavigation = () => {
    const { t } = useTranslation();
    const { localize } = useLanguage();

    const mainNav: NavItem[] = [
        { label: t('layout.nav.map'), to: localize(Path.MAP) },
        { label: t('layout.nav.home'), to: localize(Path.EXEMPLE_HOME) },
    ];
    const footerSections: FooterSection[] = [
        { title: t('layout.footer.discover'), items: mainNav },
    ];

    return { mainNav, footerSections };
};
